if (!customElements.get("sticky-content")) {
    class a extends HTMLElement {
        constructor() {
            super();
            this.media = window.matchMedia("(min-width: 992px)");
            this.media.addEventListener("change", () => this.onResize());
            this.sticky = void 0;
            this.content = this.querySelector("[data-sticky-content]");
            this.settings = {
                topSpacing: this.content.getAttribute("data-top-spacing") ? parseInt(this.content.getAttribute("data-top-spacing")) : 24,
                bottomSpacing: this.content.getAttribute("data-bottom-spacing") ? parseInt(this.content.getAttribute("data-bottom-spacing")) : 0
            };
            window.addEventListener("resize", () => {
                this.resize()
            });
            this.onResize();

            // Setup ResizeObserver to update sticky bounds when content height changes (like expanding drawers or changing variants)
            this.resizeObserver = new ResizeObserver(() => {
                if (this.sticky && typeof this.sticky.updateSticky === 'function') {
                    this.sticky.updateSticky();
                } else if (this.sticky) {
                    // fallback if updateSticky isn't available, but try to trigger resize recalculation
                    window.dispatchEvent(new Event('resize'));
                }
            });
            this.resizeObserver.observe(this.content);
        }
        resize() {
            void 0 !== this.sticky && (this.sticky.sidebarInner.style.width = this.content.offsetWidth + "px")
        }
        onResize() {
            this.media.matches ? void 0 === this.sticky && (this.sticky = new StickySidebar(this.content, {
                topSpacing: this.settings.topSpacing,
                bottomSpacing: this.settings.bottomSpacing
            })) : void 0 !== this.sticky && (this.sticky.destroy(), this.sticky = void 0)
        }
        disconnectedCallback() {
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.sticky) this.sticky.destroy();
        }
    }
    customElements.define("sticky-content", a)
}